import { render } from "./Slideshow.vue?vue&type=template&id=5f6b8bb2&scoped=true"
import script from "./Slideshow.vue?vue&type=script&lang=js"
export * from "./Slideshow.vue?vue&type=script&lang=js"

import "./Slideshow.vue?vue&type=style&index=0&id=5f6b8bb2&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f6b8bb2"]])

export default __exports__